class aspectsMenuController {

    constructor(StepLearningEngagementService, $stateParams) {
        this.$stateParams = $stateParams;
        this.stepLearningEngagementService = StepLearningEngagementService;
        this.currentAspectNr = $stateParams.aspectNr || 0;
    }

    $onInit() {
        this.init();
    }

    init() {
        this.getAspects();
    }

    isCurrentAspect(index) {
        return index === parseInt(this.$stateParams.aspectNr);
    }

    getAspects() {
        this.stepLearningEngagementService.getAspects().then((data) => {
            this.aspects = data;
            if (this.currentAspectNr) {
                this.currentAspect = this.aspects[this.currentAspectNr];
            }
        });
    }
}

aspectsMenuController.$inject = [
    'StepLearningEngagementService',
    '$stateParams',
];

export default aspectsMenuController;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningEngagement/aspectsMenu/aspectsMenuController.js